/* Endurrad — menu utente dell'header (snippets/erd-account.liquid). Apre e chiude il riquadro, «Garage» apre le moto della barra in alto. */
(function () {
  if (window.__erdAcc) return;
  window.__erdAcc = true;

  function chiudi(box) {
    var pop = box.querySelector('[data-erd-acc-pop]');
    var btn = box.querySelector('[data-erd-acc-btn]');
    if (!pop || pop.hidden) return;
    pop.hidden = true;
    box.classList.remove('is-open');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }
  function chiudiTutti(tranne) {
    document.querySelectorAll('[data-erd-acc]').forEach(function (b) { if (b !== tranne) chiudi(b); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-erd-acc-btn]');
    if (btn) {
      var box = btn.closest('[data-erd-acc]');
      var pop = box.querySelector('[data-erd-acc-pop]');
      var apri = pop.hidden;
      chiudiTutti(box);
      pop.hidden = !apri;
      box.classList.toggle('is-open', apri);
      btn.setAttribute('aria-expanded', apri ? 'true' : 'false');
      if (apri) {
        var primo = pop.querySelector('a, button:not([data-erd-acc-close])');
        if (primo) setTimeout(function () { primo.focus({ preventScroll: true }); }, 30);
      }
      return;
    }
    if (e.target.closest('[data-erd-acc-close]')) {
      chiudi(e.target.closest('[data-erd-acc]'));
      return;
    }
    var g = e.target.closest('[data-erd-acc-garage]');
    if (g) {
      chiudiTutti();
      var sel = document.querySelector('[data-erd-garage-btn]') || document.querySelector('[data-erd-sel-btn]');
      if (sel) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(function () { sel.click(); }, 200);
      }
      return;
    }
    if (e.target.closest('[data-erd-acc-pop] a') || !e.target.closest('[data-erd-acc-pop]')) chiudiTutti();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var aperto = document.querySelector('[data-erd-acc].is-open');
    if (!aperto) return;
    chiudi(aperto);
    var b = aperto.querySelector('[data-erd-acc-btn]');
    if (b) b.focus();
  });
})();
